// src/helpers/longTextHelpers.js
export const getInitialValues = (drawerData, idx) => {
    const state = drawerData[idx]?.state || {};
    return {
      longTextValue: state.longTextValue || "یک عنوان وارد کنید",
      mainTextareaValue: state.mainTextareaValue || "",
      subLongTextValue: state.subLongTextValue || "",
    };
  };
  
  export const updateDrawerState = (drawerData, idx, nextState, readOnly) => {
    if (!drawerData[idx]) return;
    drawerData[idx].state = { ...drawerData[idx].state, ...nextState, readOnly };
  };
  
  export const clamp400 = (value) =>
    value.length <= 400 ? value : value.slice(0, 400);
  